'use client';

import {
  HomeLandingSections,
  HomeStoriesSection,
  HomeCommunitySection,
  HomeVoicesSection,
  HomeAboutSection,
  CommunityMatrimonyServices,
} from '@/components/homePageSections';

import { useState } from 'react';
import Header from '@/components/Header';
import HomeHeroSection from '@/components/HomeHeroSection';

const faqItems = [
  { question: 'How to search Maratha Divorcee Brides online?', answer: 'To search Maratha Samaj grooms and brides, register free through MarathiVadhuVarSuchak.com matrimony app.' },
  { question: 'How to search Maratha Brides List online?', answer: "To search verified Maratha bride's profiles, you can register free on MarathiVadhuVarSuchak.com Marathi matrimony app." },
  { question: 'How to do search for Maratha Vadhu Var Suchak Kendra Mumbai?', answer: 'Visit MarathiVadhuVarSuchak.com site for free registration. This is most trusted Maratha Vadhu Var Suchak Kendra in Mumbai.' },
  { question: 'How to search Maratha Vadhu Var Suchak Kendra Photos with profile?', answer: 'To search Maratha grooms and brides profiles with photo, register free on MarathiVadhuVarSuchak.com site.' },
  { question: 'How to search Maratha Groom online?', answer: 'To search Maratha grooms online, you have to register free through MarathiVadhuVarSuchak.com matrimony app.' },
  { question: 'Which is the best Pune Maratha Vadhu Var Suchak Kendra?', answer: 'MarathiVadhuVarSuchak.com matrimony is the most trusted Maratha Vadhu Var Suchak Kendra for Pune-based brides and grooms.' },
  { question: 'How to search the Maratha Divorcee Grooms online?', answer: 'To search the Maratha Divorcee Grooms online, register free on MarathiVadhuVarSuchak.com matrimony portal.' },
  { question: 'How to search the second marriage Maratha divorcee brides online?', answer: 'To search the Maratha divorcee brides for second marriage online, register free through MarathiVadhuVarSuchak.com matrimonial app.' },
  { question: 'How to search the Maratha Divorcee girl online?', answer: "MarathiVadhuVarSuchak.com matrimonial app is the trusted brand to search verified Maratha Divorcee bride's profiles online." },
  { question: 'Which is the best 96 Kuli Maratha Vadhu Var Suchak Kendra?', answer: 'For 96 Kuli Maratha Vadhu Var, the MarathiVadhuVarSuchak.com matrimonial site is the trusted brand for free registration.' },
  { question: 'Which is the trusted Maratha Matrimony?', answer: 'MarathiVadhuVarSuchak.com matrimonial mobile app is the trusted Maratha Matrimony in Maharashtra.' },
  { question: 'How to search Maratha Grooms online?', answer: 'Register free through MarathiVadhuVarSuchak.com to search Maratha Grooms online.' },
];

const communityServices: { label: string; href?: string }[] = [
  { label: "Maratha Divorcee Brides" },
  { label: "Maratha" },
  { label: "Maratha Brides" },
  { label: "Maratha Brides List" },
  { label: "Maratha Vadhu Var Suchak Kendra" },
  { label: "Maratha Vadhu Var Suchak Kendra Photos" },
  { label: "Maratha Groom" },
  { label: "Pune Maratha Vadhu Var Suchak Kendra" },
  { label: "Maratha bride" },
  { label: "Pune Maratha" },
  { label: "Maratha divorcee grooms" },
  { label: "Second Marriage Maratha divorcee brides" },
  { label: "Maratha Divorcee Girl" },
  { label: "Maratha Pune" },
  { label: "96 Kuli Maratha Vadhu Var Suchak Kendra" },
  { label: "Maratha Matrimony" },
  { label: "Maratha Vadhu" },
  { label: "Maratha Grooms" },
  { label: "Maratha Vadhu Var Suchak" },
  { label: "Maratha Vadhu Var Suchak Kendra Reviews" },
  { label: "Maratha Vadhu Var Suchak Center, Akurdi" },
  { label: "Maratha Matrimony" },
];

export default function BadheMarathaVadhuVarSuchakKendraClient() {
  const [openFAQ, setOpenFAQ] = useState<number | null>(null);

  return (
    <div className="bg-white">
      <Header variant="transparent" />

      <HomeHeroSection
        title="मराठा समाजातील वधू वरांसाठी"
        subtitle="महाराष्ट्रातील अग्रणी विवाहसंस्था"
        trackingSource="badhe_maratha_vadhu_var_suchak_kendra"
      />

      <HomeLandingSections />

      <HomeStoriesSection />

      <HomeCommunitySection />

      <HomeVoicesSection />

      <HomeAboutSection />

      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-bold text-center text-gray-900 mb-12">Frequently Asked Questions</h2>
          <div className="max-w-4xl mx-auto">
            <div className="space-y-4">
              {faqItems.map((faq, index) => (
                <div key={index} className="bg-white border border-gray-200 rounded-xl overflow-hidden shadow-sm">
                  <button
                    onClick={() => setOpenFAQ(openFAQ === index ? null : index)}
                    className="w-full px-6 py-4 text-left flex items-center justify-between hover:bg-gray-50 transition-colors"
                  >
                    <h3 className="text-lg font-semibold text-gray-900">{faq.question}</h3>
                    <svg className={`w-5 h-5 text-gray-500 transition-transform duration-300 ${openFAQ === index ? 'rotate-180' : ''}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                    </svg>
                  </button>
                  <div className={`px-6 transition-all duration-300 ease-in-out ${openFAQ === index ? 'pb-4 max-h-96 opacity-100' : 'max-h-0 opacity-0 overflow-hidden'}`}>
                    <div className="text-gray-600 leading-relaxed py-3">
                      <p className="mb-3">{faq.answer}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <CommunityMatrimonyServices
        title="Maratha Vadhu Var Suchak for Maratha Community"
        items={communityServices}
      />

    </div>
  );
}
